import * as React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate, getPreviousDate } from "@ui-seeker/utils"

import { ImageSkuBlock, SkuInfoBlock } from "@components"
import { DATE_PERIODS } from "@constants"
import { useBuildExternalURL } from "@hooks"
import { commonFiltersValue } from "@signals"
import { evolutionStockDataFilters, evolutionStockCurrentPeriod, priceDiscountEndDate } from "Pages/Pricing/PriceDiscount/@signals"


export default function skuColumn() {
	return [{
		name: 'ean', label: 'Ean',
		options: { 
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'category', label: 'Category',
		options: { display: 'excluded' }
	}, {
		name: 'brand', label: 'Brand',
		options: { display: 'excluded' }
	}, {
		name: 'skuName', label: 'Product Name',
		options: { 
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'skuName', label: 'Product Name',
		options: {
			filter:false,
			headerAlign: 'center',
			customBodyRowRenderLite: (value, { category, brand, ean, skuID, productID, siteID, skuName, reference, externalSeller }) => {
				const { productURL } = useBuildExternalURL({ siteData: { siteID, productID } })
				return <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
					<Box>
						<ImageSkuBlock
							skuID={skuID}
							skuName={skuName} />
					</Box>
					<Box>
						<SkuInfoBlock
							sku={value}
							category={category}
							brand={brand}
							ean={ean}
							reference={reference}
							productURL={productURL}
						/>
						<ShowChartCell
							skuID={skuID}
							retailerID={siteID}
							productID={productID}
							externalSeller={externalSeller}
						/>
					</Box>
				</Box>
			}
		}
	}]
}

const ShowChartCell = ({ skuID, retailerID, productID, externalSeller }) => {
    const newFilters = commonFiltersValue.peek()

    const handleClick = () => {
        priceDiscountEndDate.value = newFilters.endDate
        let startDate = formatDate(getPreviousDate({days: 29}, priceDiscountEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

        evolutionStockCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS

        evolutionStockDataFilters.value = {
            ...commonFiltersValue.peek(),
            startDate: startDate,
            endDate: priceDiscountEndDate.value,
            retailer: [retailerID],
			sku: [skuID],
			productID: [productID],
			externalSeller: externalSeller,
        }
    }

    return <Box sx={{ display: 'flex', alignItems: 'flex-end'}} onClick={handleClick} >
        <IconSeeker icon={'chart-line'} sx={{ m: .5, color: 'primary.main'}}/>
		<Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover": { textDecoration: 'underline'} }}>
            Show Stock Evolution
        </Typography>
    </Box>
}